import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addManage.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { STAFF_ENDS_TRACKER_OPTIONS } from "config/constants";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { MANAGE_GROUP, STAFF_TASKS_TEMPLATES } from "config/paths";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import AddNewMemberModal from "components/Modals/AddNewMember";
import { formatString, successMessageToast } from "helpers/common";
import { cloneDeep, isEmpty } from "lodash";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import { useCreateStaffTaskTemplateMutation, useUpdateStaffTaskTemplateMutation, useViewStaffTaskTemplateQuery } from "store/services/staff";
import taskTemplateSchema from "./addTemplateSchema";

const AddStaffTaskTemplate = () => {

    const { id: templateId } = useParams();
    const editMode = !!templateId;

    const navigate = useNavigate();


    const [initialValues, setInitialValues] = useState({ task_title: "", description: "", /* tracker_type: "" */ })
    const [status, setStatus] = useState("active");
    const [showModal, setShowModal] = useState(false);
    const [members, setMembers] = useState([]);

    const { data: templateDetails, isLoading } = useViewStaffTaskTemplateQuery({ id: templateId }, { skip: !templateId });
    const [createTemplate, { isLoading: createTemplateLoading }] = useCreateStaffTaskTemplateMutation();
    const [updateTemplate, { isLoading: updateTemplateLoading }] = useUpdateStaffTaskTemplateMutation();

    const handleChange = () => {
        setStatus(status == "active" ? "archived" : "active");
    };

    const handleSubmit = async (values) => {
        try {
            let payload = cloneDeep(values);
            // payload.tracker_type = values?.tracker_type?.value

            const response = editMode ? await updateTemplate({ id: templateId, data: payload }) : await createTemplate(payload);
            if (!response?.error) {
                successMessageToast(response?.data?.message);
                navigate(STAFF_TASKS_TEMPLATES)
            }
        } catch (error) { console.log("Error creating template"); };
    };

    useEffect(() => {

        if (!templateDetails) return;

        setInitialValues({
            task_title: templateDetails?.task_title || "",
            description: templateDetails?.description || "",
            // tracker_type: { label: formatString(templateDetails?.tracker_type), value: templateDetails?.tracker_type } || "",
        })

    }, [templateDetails]);

    return (
        <>

            <section
                className={`${styles.addManage} position-relative py-4 addManage`}
            >
                <Container fluid>
                    {isLoading ? <LoadingIndicator /> : <Row>
                        <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                            <div className="left">
                                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                                    <li className="">
                                        <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Template" : "Add New Template"}</h6>
                                    </li>
                                </ul>
                            </div>
                            <div className="right">
                                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                    <li className="">

                                    </li>
                                </ul>
                            </div>
                        </div>
                        <Col lg="12" className="my-2">
                            <Formik
                                initialValues={initialValues}
                                validationSchema={taskTemplateSchema}
                                onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {
                                    ({
                                        handleSubmit,
                                        isSubmitting,
                                        values,
                                        errors,
                                        setFieldValue,
                                        submitCount
                                    }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <AddNewMemberModal
                                                show={showModal}
                                                setShow={setShowModal}
                                                clientType={values?.group_type?.value}
                                                setMembers={setMembers}
                                            />
                                            <div
                                                className="py-3"
                                                style={{ borderTop: "1px solid #41a2a84d" }}
                                            >
                                                <Row>
                                                    <Col md="6" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0"
                                                        >
                                                            Titile
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="task_title"
                                                            type="text"
                                                            placeholder="Enter Title"
                                                            className={`${styles.formControl} form-control`}
                                                            maxLength={100}
                                                        />
                                                    </Col>
                                                    {/* <Col md="6" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0"
                                                        >
                                                            Tracker Type
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <CommonSelect
                                                            name="tracker_type"
                                                            placeholder={"Select Group Type"}
                                                            option={STAFF_ENDS_TRACKER_OPTIONS}
                                                        />
                                                    </Col> */}
                                                    <Col md="12" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0"
                                                        >
                                                            Description
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="description"
                                                            fieldType="textarea"
                                                            placeholder=""
                                                            className={`${styles.formControl}  ${styles.textarea}  form-control`}
                                                            maxLength={100}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>

                                            <Row className="mt-5 ">
                                                <Col className="my-2" lg="12">
                                                    {/* {(!isEmpty(errors) && submitCount > 0) && (
                                                        <Row className="my-2">
                                                            <Col lg="12">
                                                                <span className="error">{genericFormErrorMsg}</span>
                                                            </Col>
                                                        </Row>
                                                    )} */}
                                                    <div
                                                        className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                        style={{ borderTop: "1px solid #41a2a84d" }}
                                                    >
                                                        <Button
                                                            className="d-flex align-items-center justify-content-center commonBtn"
                                                            type="submit"
                                                            disabled={createTemplateLoading || updateTemplateLoading}
                                                        >
                                                            {createTemplateLoading || updateTemplateLoading ? <LoadingIndicator /> : "Save"}
                                                        </Button>
                                                        <Button
                                                            className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                                            type="button"
                                                            onClick={() => navigate(STAFF_TASKS_TEMPLATES)}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}

                            </Formik>
                        </Col>
                    </Row>}
                </Container>
            </section>
        </>
    );
};

export default AddStaffTaskTemplate;
